function DropdownDownIcon({
    height = 4, 
    width = 7, 
    className = '',
    color = '#727580'
}) {

    return (
        <svg 
            width={width} 
            height={height} 
            viewBox="0 0 7 4" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path 
                d="M3.08333 3.60417L0.1225 0.641875C0.0816668 0.600903 0.0510417 0.556597 0.030625 0.508958C0.0102084 0.461319 0 0.413194 0 0.364583C0 0.267361 0.0343753 0.182292 0.103125 0.109375C0.171875 0.0364583 0.2625 0 0.375 0H6.58333C6.69583 0 6.78646 0.0375005 6.85521 0.112501C6.92396 0.187501 6.95833 0.275 6.95833 0.375C6.95833 0.388889 6.9175 0.47757 6.83583 0.641042L3.875 3.60417C3.81944 3.65972 3.75694 3.70139 3.6875 3.72917C3.61806 3.75694 3.54861 3.77083 3.47917 3.77083C3.40972 3.77083 3.34028 3.75694 3.27083 3.72917C3.20139 3.70139 3.13889 3.65972 3.08333 3.60417Z" 
                fill={color}
            />
        </svg>

    )
}

export default DropdownDownIcon;